import { useEffect, useState } from "react";

function cleanText(value = "") {
  const doc = new DOMParser().parseFromString(`<div>${value}</div>`, "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
}

export default function KcmInsights() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    fetch("/api/kcm-feed")
      .then((r) => {
        if (!r.ok) throw new Error("feed failed");
        return r.text();
      })
      .then((xml) => {
        if (!active) return;
        const doc = new DOMParser().parseFromString(xml, "application/xml");
        const parsed = Array.from(doc.querySelectorAll("item")).slice(0, 3).map((item) => ({
          title: cleanText(item.querySelector("title")?.textContent || ""),
          link: item.querySelector("link")?.textContent?.trim() || "https://www.simplifyingthemarket.com/",
          description: cleanText(item.querySelector("description")?.textContent || "").slice(0, 220),
          date: item.querySelector("pubDate")?.textContent?.trim() || "",
        })).filter((item) => item.title);
        setItems(parsed);
      })
      .catch(() => {
        if (active) setItems([]);
      });
    return () => { active = false; };
  }, []);

  if (!items.length) return null;

  return (
    <section className="section kcmSection">
      <div className="wrap">
        <div className="sectionHead">
          <div>
            <p className="eyebrow dark">NATIONAL HOUSING PERSPECTIVE</p>
            <h2>Additional insight from Keeping Current Matters</h2>
            <p>BREPM uses local ARMLS data and our Phoenix experience as the primary market view. These KCM articles add useful national context for buyers, sellers and property owners.</p>
          </div>
        </div>
        <div className="cards three">
          {items.map((item) => (
            <article className="card" key={item.link}>
              {item.date && <span className="kcmDate">{new Date(item.date).toLocaleDateString()}</span>}
              <h3>{item.title}</h3>
              {item.description && <p>{item.description}{item.description.length >= 220 ? "…" : ""}</p>}
              <a className="textlink" href={item.link} target="_blank" rel="noreferrer">Read on KCM →</a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
